import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateTimeToDate, getSafe } from '../../../shared/utility';
import {
  MODEL_SELECTION_RELEASES,
  MODEL_SELECTION_SELECTED_RELEASE,
  TARGET_SELECTION_SELECTED_TARGET,
  TARGET_SELECTION_TARGETS,
} from '../../../shared/const/Routes/statePaths';
import {
  getTargets,
  setSelectedTarget,
} from '../../../store/actions/jobConfiguration/jobConfiguration';
import { TARGET_SELECTION_TABLE } from '../../../shared/const/GenericTableParams/TargetSelection';

import './TargetSelection.scss';
import GenericTable from '../../../components/UI/GenericTable/GenericTable';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';

const TargetSelection = props => {
  const { subProject, setNextDisabled, filters } = props;

  const dispatch = useDispatch();
  const tableData = useSelector(state =>
    getSafe(TARGET_SELECTION_TARGETS, state)
  );
  const selectedRelease = useSelector(state =>
    getSafe(MODEL_SELECTION_SELECTED_RELEASE, state)
  );
  const selectedTarget = useSelector(state =>
    getSafe(TARGET_SELECTION_SELECTED_TARGET, state)
  );
  const releaseData = useSelector(state =>
    getSafe(MODEL_SELECTION_RELEASES, state)
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setNextDisabled(true);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getTargets(subProject?.projectId, selectedRelease, filters));
  }, [selectedRelease, filters]);

  useEffect(() => {
    if (tableData) {
      setIsLoading(false);
    }
  }, [tableData]);

  useEffect(() => {
    if (selectedTarget == null) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [selectedTarget]);

  return (
    <div className="targets-table-wrapper">
      <div className="target-selection-header">
        <label className="project-sub-title target-selection-title">
          {subProject?.projectName}-
          {
            releaseData.find(release => release.ReleaseId == selectedRelease)
              .ReleaseName
          }
        </label>
        <div className="flex-column">
          <label className="target-selection-field-name">Release Date:</label>
          <label className="target-selection-field-data">
            {formatDateTimeToDate(
              releaseData.find(release => release.ReleaseId == selectedRelease)
                .ReleaseDate
            )}
          </label>
        </div>
        <div className="flex-column">
          <label className="target-selection-field-name">Release Owner:</label>
          <label className="target-selection-field-data">
            {
              releaseData.find(release => release.ReleaseId == selectedRelease)
                .ReleaseOwner
            }
          </label>
        </div>

        <div className="flex-column">
          <label className="target-selection-field-name">
            Release Expected Deletion:
          </label>
          <label className="target-selection-field-data">
            {formatDateTimeToDate(
              releaseData.find(release => release.ReleaseId == selectedRelease)
                .ReleaseDeletionDate
            )}
          </label>
        </div>
      </div>
      <LoadingOverlay loading={isLoading}>
        {tableData ? (
          <GenericTable
            rows={tableData}
            columns={TARGET_SELECTION_TABLE.columns}
            filteringStateColumnExtensions={
              TARGET_SELECTION_TABLE.filteringStateColumnExtensions
            }
            tableColumnExtensions={TARGET_SELECTION_TABLE.tableColumnExtensions}
            filteringEnabled={false}
            tableKey={TARGET_SELECTION_TABLE.tableKey}
            pagingEnabled={false}
            selectedRowStatePath={TARGET_SELECTION_SELECTED_TARGET}
            setSelectedRow={setSelectedTarget}
          />
        ) : null}
      </LoadingOverlay>
    </div>
  );
};

export default TargetSelection;
